import React from 'react';

interface ExpandLinkProps {
  value: string;
  id: number | string;
  onToggleExpandDetail: () => void;
  title?: string;
  /* Custom extension which is next to the name value, it can be any component.*/
  extension?: any;
}

/**
 * Simple component to render a link to expand or collapse Blaze Table detail
 */
const ExpandLink = (props: ExpandLinkProps) => {
  const toggleExpandDetail = (event: any) => {
    event.preventDefault();
    props.onToggleExpandDetail();
  };

  return (
    <div className={'d-flex justify-content-start'}>
      <a
        href="#"
        id={'qa-link-expand-collapse-detail-' + props.id}
        title={props.title ? props.title : props.value}
        className={'d-inline-block align-middle text-truncate text-primary'}
        onClick={event => {
          toggleExpandDetail(event);
        }}
      >
        {props.value}
      </a>
      <span>{props.extension}</span>
    </div>
  );
};

export default ExpandLink;
